"use client"; 

export default function GlobalError({error}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  console.log("Global error", error);
  return (
    <html>
      <head>
        {/* This boundary replaces the whole document, including the real <title>.
            Without these, a crawler that hits an error render indexes the page
            under the <h1> below. */}
        <title>Der opstod en fejl</title>
        <meta name="robots" content="noindex, nofollow" />
      </head>
      <body>
        <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", marginTop: "100px" }}>
          <h1 style={{ fontSize: "1.25rem", marginBottom: "0.5rem" }}>
            Oops, something went wrong!
          </h1>
        </div>
      </body>
    </html>
  );
}
